import { Pipe, PipeTransform } from '@angular/core';
import { ProductType } from '../../enums/global-enums';

@Pipe({
  name: 'ProductTypeToFriendlyPipe'
})
export class ProductTypeToFriendlyPipe implements PipeTransform {

  transform(value: ProductType, args?: any): any {
    return ProductType[value];
  }

}
